import { compose } from 'ramda';

import { offerSelector } from './offer';
import { getIsCommercialByOffer } from '../../../utils/getIsCommercialByOffer';

export const isCommercialSelector = compose(getIsCommercialByOffer, offerSelector);
